import {
  followDirectionsLevels,
  friendshipStoriesLevels,
  targetSearchLevels
} from "@/content/focus-social";
import type { LevelDefinition } from "@/domain";
import { createLevelDefinitionSchema } from "@/domain/schemas/level";
import {
  instructionPayloadSchema,
  type InstructionPayload
} from "@/game/templates/instruction";
import {
  scenarioPayloadSchema,
  type ScenarioPayload
} from "@/game/templates/scenario";
import {
  targetSearchPayloadSchema,
  type TargetSearchPayload
} from "@/game/templates/search";

interface LevelParser<TPayload> {
  parse(value: unknown): LevelDefinition<TPayload>;
}

function parseLevels<TPayload>(
  sourceLevels: readonly unknown[],
  schema: LevelParser<TPayload>
): readonly LevelDefinition<TPayload>[] {
  return sourceLevels.map((level) => schema.parse(level));
}

export const focusSocialTargetSearchPlayerLevels =
  parseLevels<TargetSearchPayload>(
    targetSearchLevels,
    createLevelDefinitionSchema(targetSearchPayloadSchema)
  );

export const focusSocialFollowDirectionsPlayerLevels =
  parseLevels<InstructionPayload>(
    followDirectionsLevels,
    createLevelDefinitionSchema(instructionPayloadSchema)
  );

export const focusSocialFriendshipStoryPlayerLevels =
  parseLevels<ScenarioPayload>(
    friendshipStoriesLevels,
    createLevelDefinitionSchema(scenarioPayloadSchema)
  );

export const focusSocialPlayerLevels: readonly LevelDefinition[] = [
  ...focusSocialTargetSearchPlayerLevels,
  ...focusSocialFollowDirectionsPlayerLevels,
  ...focusSocialFriendshipStoryPlayerLevels
];
